import BaseComponent from "../../../baseComponent.js";
import styles from "./styles.scss";

export default class Toggle extends BaseComponent {
  constructor(props) {
    super(props);
  }

  handleChange(event) {
    this.props.onLegendChange(this.props.field, this.refs.checkBox.checked, this.props.isChartTypeParameters);
  }

  componentDidUpdate() {
    this.refs.checkBox.checked = this.props.value;
  }

  componentDidMount() {
    this.refs.checkBox.checked = this.props.value;
}

  render() {
    return (
      <div className={styles.configLineWrapper}>
        <div className={styles.configLine}>
          <div className={styles.configLabel}>{this.props.label}</div>
          <div className={styles.configValue}>
            <div className="switch" style={{lineHeight: "30px"}}>
              <label>
                Off
                <input type="checkbox" ref="checkBox" onChange={this.handleChange}/>
                <span className="lever"/>
                On
              </label>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/legend-config/toggle.jsx